import type { SegmentMstSetting } from './SegmentMstSetting';

class SegmentMstSettingProvider {
  /**
   * contextで使うセグメントマスタ設定情報
   *
   * @param key セグメントマスタを特定するためのキー
   */
  private constructor(
    readonly key: number,
    readonly displayName: string,
    readonly higherRankSegmentMstKey: number | null,
    readonly length: number,
  ) {}

  static fromSetting(setting: SegmentMstSetting) {
    return new SegmentMstSettingProvider(
      setting.segmentMstKey,
      setting.displayName,
      setting.segmentMstKey === 1 ? null : setting.segmentMstKey - 1,
      +setting.codeDigits,
    );
  }

  static fromSettings(settings: SegmentMstSetting[]) {
    return settings.filter((setting) => setting.isUsed).map(SegmentMstSettingProvider.fromSetting);
  }
}

export { SegmentMstSettingProvider };
